import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		paddingTop: spacing.lg,
		backgroundColor: 'transparent !important',
	},
	databoardContainer: {
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		backgroundColor: 'transparent !important',
	},
	infoHeaderContentBold: {
		marginTop: spacing.xs,
		marginBottom: 12,
		fontWeight: typography.fontWeights.bold,
	},
	viewOnlyModeBannerContent: {
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		padding: '20px 20px 20px 40px',
		gap: spacing.sm,
	},
	viewOnlyModeBannerContainer: {
		justifyContent: 'space-between',
		display: 'flex',
		background: colors.tertiary.light,
		// #78DBFF has no exact THEME token; keeping the literal preserves the existing banner accent.
		borderLeft: '3px solid #78DBFF',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: colors.text.main,
		alignItems: 'flex-start',
		marginBottom: spacing.md,
	},
	loadingRow: {
		height: 300,
	},
	searchInput: {
		width: 300,
		minWidth: 200,
		flexShrink: 1,
	},
	jobNumberButton: {
		padding: 0,
		height: 'auto',
		background: 'transparent',
		justifyContent: 'flex-start',
		maxWidth: '100%',
		':hover': {
			textDecoration: 'none',
		},
	},
});
